module.exports = __webpack_public_path__ + "img/co-produtor.ac0b5282.svg";